<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Share with us some information about your Business Permit</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-info2">
                            <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>This will require you to upload the required documents on Step 4.
                        </div>

                        <p class="card-text text-justify">Choose your available previous year permit:</p>
                        <div class="row">
                            <div class="col-6 text-center">
                                <div class="icheck-primary d-inline">
                                    <input type="radio" id="y-q15" value="M" v-model="formLoan.permit2019">
                                    <label for="y-q15" :class="{ 'errorRadio': submitting && $v.formLoan.permit2019.$error }">Mayor's Permit</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="icheck-primary d-inline">
                                    <input type="radio" id="n-q15" value="B" v-model="formLoan.permit2019">
                                    <label for="n-q15" :class="{ 'errorRadio': submitting && $v.formLoan.permit2019.$error }">Barangay's Permit</label>
                                </div>
                            </div>
                        </div>
                        <div v-if="formLoan.permit2019" class="mt-4">
                            <hr>
                            <p class="card-text text-justify">Choose your available permit or proof of application of permit for the current year:</p>
                            <div class="row">
                                <div class="col-6 text-center">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="y-q16" value="M" v-model="formLoan.current_permit">
                                        <label for="y-q16" :class="{ 'errorRadio': submitting && $v.formLoan.current_permit.$error }">Mayor's Permit/Proof of Payment</label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="n-q16" value="B" v-model="formLoan.current_permit">
                                        <label for="n-q16" :class="{ 'errorRadio': submitting && $v.formLoan.current_permit.$error }">Barangay's Permit</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next()">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {
                submitting: false,
            }
        },

        validations: {
            formLoan: {
                permit2019: {
                    required
                },
                current_permit: {
                    required
                },
            },
        },
        created() {},
        methods: {
            next() {
                this.submitting = false;
                this.submitting = true;
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {} else {
                    if (this.formLoan.current_permit == 'B' && this.formLoan.permit2019 == 'M') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Invalid',
                            text: 'Mayor\'s Permit 2019 and Barangay Permit 2020 are not allowed, Kindly choose again.',
                            allowEscapeKey: false,
                            allowOutsideClick: false,
                        })
                    } else {
                        this.$emit('next');
                    }
                }
            },


        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>